import axios from "axios";

// URL del NUEVO backend web
const API_WEB_BASE_URL =
  process.env.REACT_APP_API_WEB_URL || "https://fracto-web-back.fly.dev";

// Cliente para el nuevo backend web (profesor, estudiante)
export const apiClientWeb = axios.create({
  baseURL: API_WEB_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Interceptor para agregar el token de autenticación
apiClientWeb.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("accessToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor para manejar errores de respuesta
apiClientWeb.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // No redirigir automáticamente, dejar que ProtectedRoute maneje la autenticación
    return Promise.reject(error);
  }
);
